import { render, staticRenderFns } from "./PlatformsListFilter.vue?vue&type=template&id=ea6c848c&"
import script from "./PlatformsListFilter.vue?vue&type=script&lang=js&"
export * from "./PlatformsListFilter.vue?vue&type=script&lang=js&"
import style0 from "./PlatformsListFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports